<accredible-dialog-template
  [centered]="true"
  [actionBtnText]="actionBtnText()"
  [actionBtnColor]="actionBtnColor()"
  [actionBtnType]="actionBtnType()"
  [actionBtnDisabled]="
    actionBtnDisabled() || (checkboxText() ? !checkboxFormControl?.value : false)
  "
  [cancelBtnText]="cancelBtnText()"
  [cancelBtnColor]="cancelBtnColor()"
  [cancelBtnType]="cancelBtnType()"
  [preventCloseOnCancel]="preventCloseOnCancel()"
  [title]="confirmDialogHeader()"
  [isLoading]="isLoading()"
  (actionBtnClicked)="confirm()"
  (cancelBtnClicked)="cancel()">
  <div class="confirm-dialog">
    @if (confirmDialogImage()) {
      <img [src]="confirmDialogImage()" alt="" />
    }

    <h1 class="font-l-semibold">
      {{ confirmDialogTitle() }}
    </h1>

    <div class="confirm-dialog-content">
      @if (confirmDialogText()) {
        <div [innerHTML]="confirmDialogText()"></div>
      }

      @if (checkboxText()) {
        <div class="checkbox-wrapper">
          <accredible-checkbox-input
            data-cy="input-confirm-dialog-checkbox"
            [formControlRef]="checkboxFormControl"
            [label]="checkboxText()" />
        </div>
      }

      <ng-content />
    </div>
  </div>
</accredible-dialog-template>
